import script from "./VacancyCompanyItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VacancyCompanyItem.vue?vue&type=script&setup=true&lang=js"

import "./VacancyCompanyItem.vue?vue&type=style&index=0&id=046739ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-046739ac"]])

export default __exports__